// removed by extract-text-webpack-plugin
module.exports = {"DropZone":"DataLoader__DropZone__1wMDW","DottedBox":"DataLoader__DottedBox__3UPVs","LnrUpload":"DataLoader__LnrUpload__2wsmh","Error":"DataLoader__Error__yu10T","Success":"DataLoader__Success__pR-md","success":"DataLoader__success__1T5B9","Active":"DataLoader__Active__WE6Df","pulse":"DataLoader__pulse__2aw4u","SampleDownload":"DataLoader__SampleDownload__qqfJH","pulseX":"DataLoader__pulseX__3fCkf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataLoader/DataLoader.css
// module id = 162
// module chunks = 0